import axios from 'axios';
import { store } from '../store';
import { refreshTokenInterceptor } from './interceptors/refreshToken.interceptor';

const create = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://api.academia-inversapiens.com/api',
  });

  instance.interceptors.request.use((config) => {
    const { token } = store.getState().auth;
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    refreshTokenInterceptor(instance)
  );

  return instance;
};

export default create;
